export default {
  'paymentList.title': '支付列表',
  'paymentList.form.profileName': '配置名称',
  'paymentList.form.profileName.placeholder': '请选择配置名称',
  'paymentList.form.search': '查询',
  'paymentList.form.reset': '重置',
  'paymentList.operation.add': '新增',
  'paymentList.operation.delete': '删除',
  'paymentList.columns.merchant': '商户名称',
  'paymentList.columns.profileName': '配置名称',
  'paymentList.columns.profileType': '配置类型',
  'paymentList.columns.status': '状态',
  'paymentList.columns.createdAt': '创建时间',
  'paymentList.columns.updatedAt': '更新时间',
  'paymentList.columns.operations': '操作',
  'paymentList.columns.operations.view': '查看',
  'paymentList.modal.view': '查看支付配置',
  'paymentList.columns.operations.edit': '编辑',
  'paymentList.columns.operations.duplicate': '复制',
  'paymentList.columns.operations.delete': '删除',
  'paymentList.columns.operations.deleteConfirm': '确定要删除这条记录吗？',
  'paymentList.status.active': 'Active',
  'paymentList.status.inactive': 'Inactive',
  'paymentList.profileType.card': '信用卡',
  'paymentList.profileType.scard': '续费信用卡',
  'paymentList.profileType.paypal': 'Paypal',
  'paymentList.profileType.additional': '本地支付',
  'paymentList.delete.confirm': '确定要删除选中的配置吗？',
  'paymentList.delete.success': '删除成功',
  'paymentList.delete.failed': '删除失败',
  'paymentList.delete.noSelection': '请先选择要删除的配置',
  'paymentList.duplicate.success': '复制成功',
  'paymentList.duplicate.failed': '复制失败',
  'paymentList.modal.add': '新增支付配置',
  'paymentList.modal.profileName': '配置名称',
  'paymentList.modal.profileName.placeholder': '请输入配置名称',
  'paymentList.modal.profileName.required': '请输入配置名称',
  'paymentList.modal.profileType': '配置类型',
  'paymentList.modal.profileType.placeholder': '请选择配置类型',
  'paymentList.modal.profileType.required': '请选择配置类型',
  'paymentList.modal.merchant': '商户',
  'paymentList.modal.merchant.required': '请选择商户',
  'paymentList.modal.gateways': '网关列表',
  'paymentList.modal.gateways.required': '请至少选择一个网关',
  'paymentList.modal.fetchGatewayFailed': '获取网关列表失败',
  'paymentList.modal.createSuccess': '创建成功',
  'paymentList.modal.createFailed': '创建失败',
  'paymentList.modal.edit': '编辑支付配置',
  'paymentList.modal.updateSuccess': '更新成功',
  'paymentList.modal.updateFailed': '更新失败',
  'paymentList.gateway.columns.alias': '别名',
  'paymentList.gateway.columns.gatewayType': '网关类型',
  'paymentList.gateway.columns.status': '状态',
  'paymentList.edit.selectedGateways': '已选择网关',
  'paymentList.edit.dragToSort': '拖拽排序',
  'paymentList.edit.noSelectedGateways': '暂无已选择的网关',
  'paymentList.edit.allGateways': '所有网关',
  'paymentList.edit.searchGateway': '搜索网关',
  'paymentList.edit.noAvailableGateways': '暂无可用网关',
  'paymentList.edit.save': '保存',
  'paymentList.edit.create': '创建',
  'paymentList.edit.cancel': '取消并返回',
  'paymentList.edit.gatewayNotActive': '该网关非正常状态，无法添加',
  'paymentList.edit.loadDetailFailed': '加载支付配置详情失败',
  'paymentList.edit.merchantInfoError': '无法获取商户信息，请刷新页面重试',
};
